import * as requests from './requests'
import constants from './constants'
import urls from './urls'

// Provincias
export async function getProvincias() {
  return requests
    .get(constants.API_URL_LOGISTICA_PEDIDO, urls.GET_PROVINCIAS)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateProvincia(payload) {
  return requests
    .put(constants.API_URL_LOGISTICA_PEDIDO, urls.PUT_PROVINCIA_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Fecha No Entrega

export async function insertFechaNoEntrega(payload) {
  return requests
    .post(constants.API_URL_LOGISTICA_PEDIDO, urls.POST_FECHA_NO_ENTREGA_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getFechasNoEntrega() {
  return requests
    .get(constants.API_URL_LOGISTICA_PEDIDO, urls.GET_FECHAS_NO_ENTREGA)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getFechaNoEntregaById(payload) {
  return requests
    .get(constants.API_URL_LOGISTICA_PEDIDO, `${urls.GET_FECHA_NO_ENTREGA_BY_ID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateFechaNoEntrega(payload) {
  return requests
    .put(constants.API_URL_LOGISTICA_PEDIDO, urls.PUT_FECHA_NO_ENTREGA_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteFechaNoEntrega(payload) {
  return requests
    .remove(constants.API_URL_LOGISTICA_PEDIDO, `${urls.DELETE_FECHA_NO_ENTREGA_BY_ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function getFechasNoEntregaProvincia(payload) {
  return requests
    .get(constants.API_URL_LOGISTICA_PEDIDO, `${urls.GET_FECHAS_NO_ENTREGA_PROVINCIA}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateFechaNoEntregaProvincia(payload) {
  return requests
    .put(constants.API_URL_LOGISTICA_PEDIDO, urls.PUT_FECHA_NO_ENTREGA_PROVINCIA_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteFechasNoEntregaProvincias(payload) {
  return requests
    .remove(
      constants.API_URL_LOGISTICA_PEDIDO,
      `${urls.DELETE_FECHAS_NO_ENTREGA_PROVINCIA_BY_FECHA_ID}/${payload}`,
    )
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function getFechasNoEntregaCategoriaPerso(payload) {
  return requests
    .get(
      constants.API_URL_LOGISTICA_PEDIDO,
      `${urls.GET_FECHAS_NO_ENTREGA_CATEGORIA_PERSO}/${payload}`,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateFechaNoEntregaCategoriaPerso(payload) {
  return requests
    .put(
      constants.API_URL_LOGISTICA_PEDIDO,
      urls.PUT_FECHA_NO_ENTREGA_CATEGORIA_PERSO_UPDATE,
      payload,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteFechaNoEntregaCategoriaPerso(payload) {
  return requests
    .remove(
      constants.API_URL_LOGISTICA_PEDIDO,
      `${urls.DELETE_FECHAS_NO_ENTREGA_CATEGORIA_PERSO_BY_FECHA_ID_CATEGORIA_ID}/${payload.fechaNoEntregaId}/${payload.categoriaPersonalizadoId}`,
    )
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function getFechasNoEntregaCategoriaPersoDia(payload) {
  return requests
    .get(
      constants.API_URL_LOGISTICA_PEDIDO,
      `${urls.GET_FECHAS_NO_ENTREGA_CATEGORIA_PERSO_DIA}/${payload}`,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateFechaNoEntregaCategoriaPersoDia(payload) {
  return requests
    .put(
      constants.API_URL_LOGISTICA_PEDIDO,
      urls.PUT_FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_UPDATE,
      payload,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteFechasNoEntregaCategoriaPersoDia(payload) {
  return requests
    .remove(
      constants.API_URL_LOGISTICA_PEDIDO,
      `${urls.DELETE_FECHAS_NO_ENTREGA_CATEGORIA_PERSO_DIA_BY_DIA_ID}/${payload}`,
    )
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function getFechasNoEntregaDias() {
  return requests
    .get(constants.API_URL_LOGISTICA_PEDIDO, urls.GET_FECHAS_NO_ENTREGA_DIA)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateFechaNoEntregaDia(payload) {
  return requests
    .put(constants.API_URL_LOGISTICA_PEDIDO, urls.PUT_FECHA_NO_ENTREGA_DIA_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getFechasNoEntregaConfiguracionCategoria(payload) {
  return requests
    .get(
      constants.API_URL_LOGISTICA_PEDIDO,
      `${urls.GET_FECHAS_NO_ENTREGA_CONFIGURACION_CATEGORIA}/${payload}`,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateFechaNoEntregaConfiguracionCategoria(payload) {
  return requests
    .put(
      constants.API_URL_LOGISTICA_PEDIDO,
      urls.PUT_FECHA_NO_ENTREGA_CONFIGURACION_CATEGORIA_UPDATE,
      payload,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Franja Horarios

export async function getFranjasHorarios() {
  return requests
    .get(constants.API_URL_LOGISTICA_PEDIDO, urls.GET_FRANJAS_HORARIOS)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertFranjaHorario(payload) {
  return requests
    .post(constants.API_URL_LOGISTICA_PEDIDO, urls.POST_FRANJA_HORARIO_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateFranjaHorario(payload) {
  return requests
    .put(constants.API_URL_LOGISTICA_PEDIDO, urls.PUT_FRANJA_HORARIO_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteFranjaHorario(payload) {
  return requests
    .remove(constants.API_URL_LOGISTICA_PEDIDO, `${urls.DELETE_FRANJA_HORARIO_BY__ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function deleteFranjaHorarioEditar(payload) {
  return requests
    .remove(
      constants.API_URL_LOGISTICA_PEDIDO,
      `${urls.DELETE_FRANJA_HORARIO_RANGO_BY_ID}/${payload}`,
    )
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function getUbicacionesHorarios(payload) {
  return requests
    .post(constants.API_URL_LOGISTICA_PEDIDO, urls.GET_UBICACIONES_HORARIOS_BY_FECHA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getFranjaHorarioById(payload) {
  return requests
    .get(constants.API_URL_LOGISTICA_PEDIDO, `${urls.GET_FRANJA_HORARIO_BY_ID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getFranjasHorariosEditar(payload) {
  return requests
    .get(constants.API_URL_LOGISTICA_PEDIDO, `${urls.GET_FRANJAS_HORARIOS_EDITAR}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertFechaHorario(payload) {
  return requests
    .post(constants.API_URL_LOGISTICA_PEDIDO, urls.POST_FECHA_HORARIO_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateFranjaHorarioEditar(payload) {
  return requests
    .put(constants.API_URL_LOGISTICA_PEDIDO, urls.PUT_FRANJA_HORARIO_EDITAR_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getUbicaciones() {
  return requests
    .get(constants.API_URL_LOGISTICA_PEDIDO, urls.GET_UBICACIONES)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getUbicacionesHorariosNoEspecial() {
  return requests
    .get(constants.API_URL_LOGISTICA_PEDIDO, urls.GET_UBICACIONES_ETREGA_NO_ESPECIAL)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getUbicacionesMRW() {
  return requests
    .get(constants.API_URL_LOGISTICA_PEDIDO, urls.GET_UBICACIONES_MRW)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Dias Especiales

export async function getDiasEspeciales() {
  return requests
    .get(constants.API_URL_LOGISTICA_PEDIDO, urls.GET_DIAS_ESPECIALES)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertDiaEspecial(payload) {
  return requests
    .post(constants.API_URL_LOGISTICA_PEDIDO, urls.POST_DIA_ESPECIAL_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateDiaEspecial(payload) {
  return requests
    .put(constants.API_URL_LOGISTICA_PEDIDO, urls.PUT_DIA_ESPECIAL_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteDiaEspecial(payload) {
  return requests
    .remove(constants.API_URL_LOGISTICA_PEDIDO, `${urls.DELETE_DIA_ESPECIAL_BY_ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function duplicarDiaEspecial(payload) {
  return requests
    .post(constants.API_URL_LOGISTICA_PEDIDO, urls.POST_DIA_ESPECIAL_DUPLICAR, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getDiasEspecialesEditar(payload) {
  return requests
    .get(constants.API_URL_AGGREGATOR, `${urls.GET_DIAS_ESPECIALES_EDITAR}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteDiaEspecialEditar(payload) {
  return requests
    .remove(
      constants.API_URL_LOGISTICA_PEDIDO,
      `${urls.DELETE_DIA_ESPECIAL_EDITAR}/${payload.id}/${payload.delete}`,
    )
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function insertDiaEspecialEditar(payload) {
  return requests
    .post(constants.API_URL_LOGISTICA_PEDIDO, urls.POST_DIA_ESPECIAL_EDITAR_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getDiaEspecialById(payload) {
  return requests
    .get(constants.API_URL_LOGISTICA_PEDIDO, `${urls.GET_DIA_ESPECIAL_BY_ID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateDiaEspecialEditar(payload) {
  return requests
    .put(constants.API_URL_LOGISTICA_PEDIDO, urls.PUT_DIA_ESPECIAL_EDITAR_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Configuracion Caso 3

export async function getConfiguracionesCaso3Bis() {
  return requests
    .get(constants.API_URL_LOGISTICA_PEDIDO, urls.GET_CONFIGURACION_CASO3_BIS)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getConfiguracionesCaso3() {
  return requests
    .get(constants.API_URL_LOGISTICA_PEDIDO, urls.GET_CONFIGURACION_CASO3)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateConfiguracionesCaso3(payload) {
  return requests
    .put(constants.API_URL_LOGISTICA_PEDIDO, urls.PUT_CONFIGURACION_CASO3_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertConfiguracionesCaso3(payload) {
  return requests
    .post(constants.API_URL_LOGISTICA_PEDIDO, urls.POST_CONFIGURACION_CASO3_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteConfiguracionesCaso3Bis(payload) {
  return requests
    .remove(
      constants.API_URL_LOGISTICA_PEDIDO,
      `${urls.DELETE_CONFIGURACION_CASO3_BIS_BY_ID}/${payload}`,
    )
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function updateConfiguracionesCaso3Bis(payload) {
  return requests
    .put(constants.API_URL_LOGISTICA_PEDIDO, urls.PUT_CONFIGURACION_CASO3_BIS_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertConfiguracionesCaso3Bis(payload) {
  return requests
    .post(constants.API_URL_LOGISTICA_PEDIDO, urls.POST_CONFIGURACION_CASO3_BIS_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Codigo Postal Conflictivo MRW

export async function getCPsConflictivos() {
  return requests
    .get(constants.API_URL_LOGISTICA_PEDIDO, urls.GET_CPS_CONFLICTIVOS)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertCPConflictivo(payload) {
  return requests
    .post(constants.API_URL_LOGISTICA_PEDIDO, urls.POST_CP_CONFLICTIVO_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateCPConflictivo(payload) {
  return requests
    .put(constants.API_URL_LOGISTICA_PEDIDO, urls.PUT_CP_CONFLICTIVO_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Paises

export async function getPaises() {
  return requests.get(constants.API_URL_LOGISTICA_PEDIDO, urls.GET_PAISES).then(async response => {
    return { ok: response.ok, data: await response.json() }
  })
}

export async function insertPais(payload) {
  return requests
    .post(constants.API_URL_LOGISTICA_PEDIDO, urls.POST_PAIS_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updatePais(payload) {
  return requests
    .put(constants.API_URL_LOGISTICA_PEDIDO, urls.PUT_PAIS_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deletePais(payload) {
  return requests
    .remove(constants.API_URL_LOGISTICA_PEDIDO, `${urls.DELETE_PAIS_BY_ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

// Codigo Postal Internacional

export async function getCPInternacionales(payload) {
  return requests
    .get(constants.API_URL_LOGISTICA_PEDIDO, `${urls.GET_CP_INTERNACIONALES}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertCPInternacional(payload) {
  return requests
    .post(constants.API_URL_LOGISTICA_PEDIDO, urls.POST_CP_INTERNACIONAL_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateCPInternacional(payload) {
  return requests
    .put(constants.API_URL_LOGISTICA_PEDIDO, urls.PUT_CP_INTERNACIONAL_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteCPInternacional(payload) {
  return requests
    .remove(constants.API_URL_LOGISTICA_PEDIDO, `${urls.DELETE_CP_INTERNACIONAL_BY_ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

// Horario Entrega Madrid MRW

export async function getHorariosEntregaMRWByUbicacionId(payload) {
  return requests
    .post(
      constants.API_URL_LOGISTICA_PEDIDO,
      urls.GET_HORARIOS_ENTREGA_MADRID_BY_UBICACION_ID,
      payload,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertHorarioEntregaMRW(payload) {
  return requests
    .post(constants.API_URL_LOGISTICA_PEDIDO, urls.POST_HORARIO_ENTREGA_MADRID_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateHorarioEntregaMRW(payload) {
  return requests
    .put(constants.API_URL_LOGISTICA_PEDIDO, urls.PUT_HORARIO_ENTREGA_MADRID_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteHorarioEntregaMRW(payload) {
  return requests
    .remove(
      constants.API_URL_LOGISTICA_PEDIDO,
      `${urls.DELETE_HORARIO_ENTREGA_MADRID_BY_ID}/${payload}`,
    )
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

// Codigo Postal

export async function getCodigosPostales(payload) {
  return requests
    .post(constants.API_URL_LOGISTICA_PEDIDO, urls.GET_CPS, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getTiposCodigosPostales() {
  return requests
    .get(constants.API_URL_LOGISTICA_PEDIDO, urls.GET_TIPOS_CPS)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertCodigoPostal(payload) {
  return requests
    .post(constants.API_URL_LOGISTICA_PEDIDO, urls.POST_CP_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateCodigoPostal(payload) {
  return requests
    .put(constants.API_URL_LOGISTICA_PEDIDO, urls.PUT_CP_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteCodigoPostal(payload) {
  return requests
    .remove(constants.API_URL_LOGISTICA_PEDIDO, `${urls.DELETE_CP_BY_ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function getCodigosPostalesRestriccionesMovilidad() {
  return requests
    .get(constants.API_URL_LOGISTICA_PEDIDO, urls.GET_CPS_RESTRICCIONES_MOVILIDAD)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Fechas Bloqueadas

export async function insertFechaBloqueada(payload) {
  return requests
    .post(constants.API_URL_LOGISTICA_PEDIDO, urls.POST_FECHA_BLOQUEADA_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getFechasBloqueadas() {
  return requests
    .get(constants.API_URL_LOGISTICA_PEDIDO, urls.GET_FECHAS_BLOQUEADAS)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateFechaBloqueada(payload) {
  return requests
    .put(constants.API_URL_LOGISTICA_PEDIDO, urls.PUT_FECHA_BLOQUEADA_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteFechaBloqueada(payload) {
  return requests
    .remove(constants.API_URL_LOGISTICA_PEDIDO, `${urls.DELETE_BLOQUEADA_BY_ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

// Fechas Bloqueadas Provincia

export async function getFechasBloqueadasProvincia(payload) {
  return requests
    .get(constants.API_URL_LOGISTICA_PEDIDO, `${urls.GET_FECHAS_BLOQUEADAS_PROVINCIA}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateFechaBloqueadaProvincia(payload) {
  return requests
    .put(constants.API_URL_LOGISTICA_PEDIDO, urls.PUT_FECHA_BLOQUEADA_PROVINCIA_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteFechasBloqueadasProvincias(payload) {
  return requests
    .remove(
      constants.API_URL_LOGISTICA_PEDIDO,
      `${urls.DELETE_FECHAS_BLOQUEADAS_PROVINCIA_BY_FECHA_ID}/${payload}`,
    )
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

// Pagina Ok Template

export async function getMensajeWhatsapp() {
  return requests
    .get(constants.API_URL_LOGISTICA_PEDIDO, `${urls.GET_PAGINA_OK_SECCION_WHATSAPP}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getPaginaOkTemplateById(payload) {
  return requests
    .get(constants.API_URL_LOGISTICA_PEDIDO, `${urls.GET_PAGINA_OK_TEMPLATE_BY_ID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updatePaginaOkTemplate(payload) {
  return requests
    .put(constants.API_URL_LOGISTICA_PEDIDO, urls.PUT_PAGINA_OK_TEMPLATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getSeccionTemplateById(payload) {
  return requests
    .get(constants.API_URL_LOGISTICA_PEDIDO, `${urls.GET_SECCION_TEMPLATE_BY_ID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateSeccionTemplate(payload) {
  return requests
    .put(constants.API_URL_LOGISTICA_PEDIDO, urls.PUT_SECCION_TEMPLATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getHorariosEntregaMostrarTodo(payload) {
  return requests
    .get(
      constants.API_URL_LOGISTICA_PEDIDO,
      `${urls.GET_ALL_HORARIOS_ENTREGA}?mostrarTodo=${payload}`,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getHorariosEntregaByUbicacionId(payload) {
  return requests
    .post(
      constants.API_URL_LOGISTICA_PEDIDO,
      urls.GET_ALL_HORARIOS_ENTREGA_BY_UBICACION_ID,
      payload,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getHorarioEsFechaEspecial({ fecha, ubicacion, esCaja }) {
  const params = new URLSearchParams()
  if (fecha) params.append('fecha', fecha)
  params.append('ubicacion', ubicacion)
  params.append('esCaja', !!esCaja)

  return requests
    .get(
      constants.API_URL_LOGISTICA_PEDIDO,
      `${urls.GET_HORARIO_ENTREGA_ES_FECHA_ESPECIAL}?${params.toString()}`,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function cargarRangoHorarioEntrega({ ubicacionId, fechaEntrega, formaPagoId, codigoPostal, horarioId, mostrarTodo = true }) {
  let diaEspecial = false

  if (ubicacionId !== undefined && ubicacionId !== null && ubicacionId !== '' && fechaEntrega) {
    const esFechaEspecialResult = await getHorarioEsFechaEspecial({
      fecha: fechaEntrega,
      ubicacion: ubicacionId,
      esCaja: false,
    })
    diaEspecial = esFechaEspecialResult.ok && Array.isArray(esFechaEspecialResult.data) && esFechaEspecialResult.data.length > 0
  }

  return getHorariosEntregaByUbicacionId({
    mostrarTodo,
    diaEspecial,
    ubicacionId,
    horarioId,
    formaPagoId,
    codigoPostal,
    fechaEntrega,
  })
}

export async function getHorarioEntregaById(payload) {
  return requests
    .get(constants.API_URL_LOGISTICA_PEDIDO, `${urls.GET_HORARIO_ENTREGA_BY_ID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Forma Pago

export async function getFormasPago() {
  return requests
    .get(constants.API_URL_LOGISTICA_PEDIDO, urls.GET_FORMAS_PAGO)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Estado Estado Mensajeria

export async function getEstados() {
  return requests.get(constants.API_URL_LOGISTICA_PEDIDO, urls.GET_ESTADOS).then(async response => {
    return { ok: response.ok, data: await response.json() }
  })
}

export async function getEstadosMensajeria() {
  return requests
    .get(constants.API_URL_LOGISTICA_PEDIDO, urls.GET_ESTADOS_MENSAJERIA)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertEstado(payload) {
  return requests
    .post(constants.API_URL_LOGISTICA_PEDIDO, urls.POST_ESTADO_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateEstado(payload) {
  return requests
    .put(constants.API_URL_LOGISTICA_PEDIDO, urls.PUT_ESTADO_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteEstado(payload) {
  return requests
    .remove(constants.API_URL_LOGISTICA_PEDIDO, `${urls.DELETE_ESTADO_BY_ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function insertEstadoMensajeria(payload) {
  return requests
    .post(constants.API_URL_LOGISTICA_PEDIDO, urls.POST_ESTADO_MENSAJERIA_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateEstadoMensajeria(payload) {
  return requests
    .put(constants.API_URL_LOGISTICA_PEDIDO, urls.PUT_ESTADO_MENSAJERIA_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteEstadoMensajeria(payload) {
  return requests
    .remove(constants.API_URL_LOGISTICA_PEDIDO, `${urls.DELETE_ESTADO_MENSAJERIA_BY_ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

// Fecha Color

export async function insertFechaColor(payload) {
  return requests
    .post(constants.API_URL_LOGISTICA_PEDIDO, urls.POST_FECHA_COLOR_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getFechasColor() {
  return requests
    .get(constants.API_URL_LOGISTICA_PEDIDO, urls.GET_FECHAS_COLOR)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateFechaColor(payload) {
  return requests
    .put(constants.API_URL_LOGISTICA_PEDIDO, urls.PUT_FECHA_COLOR_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteFechaColor(payload) {
  return requests
    .remove(constants.API_URL_LOGISTICA_PEDIDO, `${urls.DELETE_COLOR_BY_ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

// Dhl Descripcion

export async function getDhlDescripciones() {
  return requests
    .get(constants.API_URL_LOGISTICA_PEDIDO, urls.GET_DHL_DESCRIPCIONES)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertDhlDescripcion(payload) {
  return requests
    .post(constants.API_URL_LOGISTICA_PEDIDO, urls.POST_DHL_DESCRIPCION_INSERT, payload)
    .then(response => {
      return { ok: response.ok }
    })
}

export async function deleteDhlDescripcion(id) {
  return requests
    .remove(constants.API_URL_LOGISTICA_PEDIDO, `${urls.DELETE_DHL_DESCRIPCION_BY_ID}/${id}`)
    .then(response => {
      return { ok: response.ok }
    })
}

// MRW Reclamaciones

export async function getMrwReclamaciones(payload) {
  const url = `${urls.GET_MRW_RECLAMACIONES}?ventaId=${payload.ventaId}&numeroEnvio=${payload.numeroEnvio}&codigoPostal=${payload.codigoPostal}&fechaEntrega=${payload.fechaEntrega}&horario=${payload.horario}&bultosCheck=${payload.bultosCheck}`
  return requests.get(constants.API_URL_LOGISTICA_PEDIDO, url).then(async response => {
    return { ok: response.ok, data: await response.json() }
  })
}

export async function procesarMrwReclamaciones(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.POST_MRW_RECLAMACIONES, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function patchMrwReclamaciones(id, payload) {
  return requests
    .jsonPatch(constants.API_URL_LOGISTICA_PEDIDO, `${urls.PATCH_MRW_RECLAMACIONES}/${id}`, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getTransportistas() {
  return requests
    .get(constants.API_URL_LOGISTICA_PEDIDO, urls.TRANSPORTISTA)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getTransportistasVacaciones() {
  return requests
    .get(constants.API_URL_LOGISTICA_PEDIDO, urls.VACACIONES_TRANSPORTISTA)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getTransportistasComentarios(payload) {
  return requests
    .get(
      constants.API_URL_LOGISTICA_PEDIDO,
      `${urls.COMENTARIOS_TRANSPORTISTA}/?fecha=${payload.fecha}`,
    )
    .then(async response => {
      // Un día sin comentarios responde 204 sin cuerpo: es una lista vacía, no un error
      return { ok: response.ok, data: response.status === 204 ? [] : await response.json() }
    })
}

export async function getTransportista(id) {
  return requests
    .get(constants.API_URL_LOGISTICA_PEDIDO, `${urls.TRANSPORTISTA}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertTransportista(payload) {
  return requests
    .post(constants.API_URL_LOGISTICA_PEDIDO, urls.TRANSPORTISTA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateTransportista(payload) {
  return requests
    .put(constants.API_URL_LOGISTICA_PEDIDO, urls.TRANSPORTISTA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteTransportista(id) {
  return requests
    .remove(constants.API_URL_LOGISTICA_PEDIDO, `${urls.TRANSPORTISTA}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertVacacionesTransportista(payload) {
  return requests
    .post(constants.API_URL_LOGISTICA_PEDIDO, urls.VACACIONES_TRANSPORTISTA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteVacacionesTransportista(id) {
  return requests
    .remove(constants.API_URL_LOGISTICA_PEDIDO, `${urls.VACACIONES_TRANSPORTISTA}/${id}`)
    .then(async response => {
      return { ok: response.ok }
    })
}

export async function deleteComentarioTransportista(id) {
  return requests
    .remove(constants.API_URL_LOGISTICA_PEDIDO, `${urls.COMENTARIOS_TRANSPORTISTA}/${id}`)
    .then(async response => {
      return { ok: response.ok }
    })
}

export async function insertComentarioTransportista(payload) {
  return requests
    .post(constants.API_URL_LOGISTICA_PEDIDO, urls.COMENTARIOS_TRANSPORTISTA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateComentarioTransportista(payload) {
  return requests
    .put(constants.API_URL_LOGISTICA_PEDIDO, urls.COMENTARIOS_TRANSPORTISTA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Horario de recogida de un mensajero en un día (input junto a su nombre en Recorridos)
export async function guardarHorarioRecogida(payload) {
  return requests
    .put(constants.API_URL_LOGISTICA_PEDIDO, urls.COMENTARIOS_TRANSPORTISTA_HORARIO, payload)
    .then(response => ({ ok: response.ok }))
}

// "Ordenar mensajeros": renumera de 1 a N los habilitados y visibles de la fecha
export async function reordenarTransportistas(payload) {
  return requests
    .post(constants.API_URL_LOGISTICA_PEDIDO, urls.REORDENAR_TRANSPORTISTAS, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Histórico de recorridos: recorrido guardado de un día, por mensajero (siempre una lista, vacía si no hay)
export async function getRecorridoHistorico(payload) {
  return requests
    .get(
      constants.API_URL_LOGISTICA_PEDIDO,
      `${urls.RECORRIDO_HISTORICO}?fecha=${payload.fecha}`,
    )
    .then(async response => {
      return { ok: response.ok, data: response.ok ? await response.json() : null }
    })
}

// Quién guardó el recorrido de un día y cuándo
export async function getRecorridoHistoricoGuardados(payload) {
  return requests
    .get(
      constants.API_URL_LOGISTICA_PEDIDO,
      `${urls.RECORRIDO_HISTORICO}/Guardados?fecha=${payload.fecha}`,
    )
    .then(async response => {
      return { ok: response.ok, data: response.ok ? await response.json() : null }
    })
}

// Guarda el recorrido de un día futuro; el servidor ignora los días que ya no lo son
export async function guardarRecorridoHistorico(payload) {
  return requests
    .put(constants.API_URL_LOGISTICA_PEDIDO, urls.RECORRIDO_HISTORICO, payload)
    .then(async response => {
      return { ok: response.ok, data: response.ok ? await response.json() : null }
    })
}

export async function getTransportistasVisibles(payload) {
  return requests
    .get(
      constants.API_URL_LOGISTICA_PEDIDO,
      `${urls.VISIBLE_TRANSPORTISTA}/?fecha=${payload.fecha}`,
    )
    .then(async response => {
      // Un día sin mensajeros visibles responde 204 sin cuerpo: es una lista vacía, no un error
      return { ok: response.ok, data: response.status === 204 ? [] : await response.json() }
    })
}

export async function deleteVisibleTransportista(id) {
  return requests
    .remove(constants.API_URL_LOGISTICA_PEDIDO, `${urls.VISIBLE_TRANSPORTISTA}/${id}`)
    .then(async response => {
      return { ok: response.ok }
    })
}

export async function insertVisibleTransportista(payload) {
  return requests
    .post(constants.API_URL_LOGISTICA_PEDIDO, urls.VISIBLE_TRANSPORTISTA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function cambiarVisibleTodosTransportista(payload) {
  return requests
    .post(
      constants.API_URL_LOGISTICA_PEDIDO,
      urls.VISIBLE_TRANSPORTISTA_MOSTRAR_OCULTAR_TODOS,
      payload,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function setMrwReclamacionManual(payload) {
  return requests
    .post(constants.API_URL_LOGISTICA_PEDIDO, urls.POST_MRW_RECLAMACION_MANUAL, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Paises info
export async function getPaisesInfo() {
  return requests
    .get(constants.API_URL_LOGISTICA_PEDIDO, urls.GET_PAISES_INFO)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getPaisesInfoFiltered(payload) {
  return requests
    .post(constants.API_URL_LOGISTICA_PEDIDO, urls.GET_PAISES_INFO_FILTERED, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Inpost
export async function transmitirInpost(payload) {
  return requests
    .post(constants.API_URL_LOGISTICA_PEDIDO, urls.POST_TRANSMITIR_INPOST, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Seur
export async function transmitirSeur(payload) {
  return requests
    .post(constants.API_URL_LOGISTICA_PEDIDO, urls.POST_TRANSMITIR_SEUR, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Limpiar datos mensajeria

export async function limpiarDatosMensajeriaVenta(payload) {
  return requests
    .remove(
      constants.API_URL_LOGISTICA_PEDIDO,
      `${urls.DELETE_LIMPIAR_DATOS_MENSAJERIA}/${payload}`,
    )
    .then(async response => {
      return { ok: response.ok, data: null }
    })
}

export async function limpiarDatosMensajeriaVentaMasivas(payload) {
  return requests
    .post(
      constants.API_URL_LOGISTICA_PEDIDO,
      urls.DELETE_LIMPIAR_DATOS_MENSAJERIA_VENTAIDS,
      payload,
    )
    .then(async response => {
      return { ok: response.ok, data: null }
    })
}

// Imprimir etiquetas ZPL

// Devuelve { verificado, courier }: courier es la mensajeria real de la venta aunque no coincida.
export async function verificarEtiquetaZpl(ventaId, courier) {
  const response = await requests.get(
    constants.API_URL_LOGISTICA_PEDIDO,
    `${urls.GET_ETIQUETAS_ZPL_VERIFICAR}/${ventaId}?courier=${courier}`,
  )
  return { ok: response.ok, data: await leerJsonEtiquetasZpl(response) }
}

// Los tres documentos devuelven el fichero en `data` si va bien, o { mensaje, ventasIds } si no.
const generarDocumentoEtiquetasZpl = async (path, ventasIds) => {
  const response = await requests.post(constants.API_URL_LOGISTICA_PEDIDO, path, { ventasIds })
  if (response.ok) return { ok: true, data: await response.blob() }
  return { ok: false, data: await leerJsonEtiquetasZpl(response) }
}

// Los errores del controller son { mensaje, ventasIds }; los anteriores a él (gateway, auth) no traen JSON.
const leerJsonEtiquetasZpl = async response => {
  try {
    return await response.json()
  } catch {
    return { mensaje: `Error ${response.status}`, ventasIds: [] }
  }
}

export const generarEtiquetasZplTxt = ventasIds =>
  generarDocumentoEtiquetasZpl(urls.POST_ETIQUETAS_ZPL_TXT, ventasIds)

export const generarEtiquetasZplPdfLabelary = ventasIds =>
  generarDocumentoEtiquetasZpl(urls.POST_ETIQUETAS_ZPL_PDF_LABELARY, ventasIds)

export const generarEtiquetasZplPdfLocal = ventasIds =>
  generarDocumentoEtiquetasZpl(urls.POST_ETIQUETAS_ZPL_PDF_LOCAL, ventasIds)

// Restricciones de Entrega

// Obtener lista de restricciones de entrega con filtros
export async function getRestriccionesEntrega(filtros = {}) {
  const queryParams = new URLSearchParams()
  
  Object.keys(filtros).forEach(key => {
    if (filtros[key] !== undefined && filtros[key] !== null && filtros[key] !== '') {
      queryParams.append(key, filtros[key])
    }
  })

  const queryString = queryParams.toString()
  const url = queryString ? `RestriccionEntrega?${queryString}` : 'RestriccionEntrega'

  return requests
    .get(constants.API_URL_LOGISTICA_PEDIDO, url)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Obtener restricción de entrega por ID
export async function getRestriccionEntregaById(id) {
  return requests
    .get(constants.API_URL_LOGISTICA_PEDIDO, `RestriccionEntrega/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Crear nueva restricción de entrega
export async function insertRestriccionEntrega(restriccion) {
  return requests
    .post(constants.API_URL_LOGISTICA_PEDIDO, 'RestriccionEntrega', restriccion)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Crear restricciones masivas
export async function insertRestriccionEntregaBulk(restriccionesBulk) {
  return requests
    .post(constants.API_URL_LOGISTICA_PEDIDO, 'RestriccionEntrega/bulk', restriccionesBulk)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Obtener lista de mensajerías
export async function getMensajerias() {
  return requests
    .get(constants.API_URL_LOGISTICA_PEDIDO, 'RestriccionEntrega/Mensajeria')
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Obtener lista de motivos de restricción
export async function getMotivosRestriccion() {
  return requests
    .get(constants.API_URL_LOGISTICA_PEDIDO, 'RestriccionEntrega/MotivoRestriccion')
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Eliminar restricciones masivas por IDs
export async function deleteRestriccionesEntregaBulk(ids) {
  return requests
    .remove(constants.API_URL_LOGISTICA_PEDIDO, 'RestriccionEntrega/bulk', ids)
    .then(async response => {
      return { ok: response.ok, data: response.status === 204 ? null : await response.json() }
    })
}

// Nota: El backend ahora soporta GET, POST, POST bulk y DELETE bulk
// Las siguientes funciones aún requieren implementación en el backend:
// - updateRestriccionEntrega (PUT)
// - deleteRestriccionEntrega (DELETE individual)
// - updateRestriccionEntregaActivo (PATCH)
